module.exports = __webpack_public_path__ + "static/media/su.2bfc5a84.png";